export class TranslationData {
  public Id: string;
  public Appli: string;
  public Code: string;
  public Type: string;
  public TradEn: string;
  public TradFr: string;
  public ModeEditable: boolean;
  public Comm: string;
  public ParamOrderBy: string;
  public PositionOrder: number;
  TranslationData() {
    this.ModeEditable = false;
  }
  

}


